export const RATING_CONTENT_STATUS = {
	active: {
		key: "active",
		label: "Active",
		value: true,
	},
	inactive: {
		key: "inactive",
		label: "Inactive",
		value: false,
	},
};

export const RATING_APP = {
	CUSTOMER: "customer",
	MERCHANT: "merchant",
};

export const RATING_TYPE = {
	APP: {
		key: "app",
		label: {
			customer: "Customer app",
			merchant: "Merchant app",
		}
	},
	LIBERTY_SERVICES: {
		key: "liberty_services",
		label: "Liberty service"
	},
	CAR: {
		key: "car",
		label: "Car"
	},
	CAR_CARE_SERVICE: {
		key: "car_wash_service",
		label: "Car care service"
	},
};

export const LANGUAGE_KEY: {
	[key: string]: {
		key: string;
		label: string;
	};
} = {
	en: {
		key: "en",
		label: "English",
	},
	zh: {
		key: "zh",
		label: "Chinese",
	},
	km: {
		key: "km",
		label: "Cambodian",
	},
};

export const MAXIMUM_ACTIVE_ITEMS = 8;
export const MINIMUM_ACTIVE_ITEMS = 1;
export const MAXIMUM_ACTIVE_ITEMS_MESSAGE = "Maximum 8 active contents for a star level";
export const MINIMUM_ACTIVE_ITEMS_MESSAGE = "Required at least 1 active content for a star level.";
export const EMPTY_ERROR_MESSAGE = "This field is required";
export const ITEM_ID_PREFIX = "__content-item__";

export const TAG_COLOR = {
	[RATING_TYPE.LIBERTY_SERVICES.label]: "#1890ff",
	[RATING_TYPE.CAR.label]: "#84ad2b",
	[RATING_TYPE.APP.label.customer]: "#002851",
	[RATING_TYPE.APP.label.merchant]: "#ffa940",
};